<template>
  <v-container class="blue lighten-5">
    <div v-for="(item, i) in toggleableLayers" :key="i">
      <v-switch
        @click="toggleLayer(item, i)"
        v-model="toggleableLayers[i].visible"
        color="blue"
      >
        <template v-slot:label>
          <img
            v-if="item.imgSrc"
            style="vertical-align: middle; padding-right:2px;"
            :src="`legend-imgs/${item.imgSrc}`"
          />
          <div>{{ item["layer-display"] }}</div>
        </template>
      </v-switch>

      <img
        class="legend-img"
        v-if="item['legend-img'] && item.visible"
        :src="`legend-imgs/${item['legend-img']}`"
      />

      <div v-if="item['dynamic-legend'] && item.visible" class="dynamic-legend-container">

        <div v-for="(l, i) in legendValues(item.tag)" :key="i" class="legend-swatch-class">
          <span
          class="legend-swatch"
            :style="{
              backgroundColor: l.color,
              border: `0px solid ${l.color}`,
            }"
          ></span>
          <span class="dynamic-legend-label text-body-2">{{ l.label }}</span>
        </div>
      </div>
    </div>
  </v-container>
</template>
<script>
import { EventBus } from "../../js/DataManagement/EventBus";
export default {
  name: "SideLegend",
  components: {},
  data: function () {
    return {
      toggleableLayers: this.$mainConfig["toggleable-layers"].filter(l => l.active === true),
    };
  },
  mounted: function () {
    let self = this;

    const layersSetOnInUrl =
      this.$querystringManager.route.query["toggledlayers"] || [];
    const toggleablelayers = self.$mainConfig["toggleable-layers"].filter(l => l.active === true);
    toggleablelayers.forEach((l, i) => {
      const ids = l["layer-ids"] || [];
     
      ids.forEach((id) => {
        const visibility =
          self.$map.getLayoutProperty(id, "visibility") === "none" &&
          !layersSetOnInUrl.includes(l.tag)
            ? false
            : true;

        self.toggleableLayers[i].visible = visibility;
      });
    });
    this.$forceUpdate();
  },
  methods: {
    legendValues(layerTag){
      switch(layerTag){
        case "cois":
          break;
        case "vote-2024-results":
          return this.$voteLayerConfig2024.config.scale;
        case "vote-results":default:
          return this.$voteLayerConfig.config.scale
      }
    },
    toggleLayer(layer, i) {
      const ids = layer["layer-ids"] || [];
      ids.forEach((id) => {
        this.$map.setLayoutProperty(
          id,
          "visibility",
          this.toggleableLayers[i].visible ? "visible" : "none"
        );

        this.$forceUpdate();
      });

      if(layer["mb-style"] && this.toggleableLayers[i].visible){
        this.$map.setStyle(layer["mb-style"]);
      }

      const layersOn = this.toggleableLayers
        .filter((l) => l.visible === true)
        .map((l) => l.tag);

      if (layersOn.length < 1) {
        this.$querystringManager.removeQueryParam("toggledlayers");
      } else {
        this.$querystringManager.addQueryParam(
          "toggledlayers",
          layersOn.join(",")
        );
      }

      if (layer["on-load-event"] && this.toggleableLayers[i].visible) {
        EventBus.$emit(layer["on-load-event"]);
      }
    },
  },
  watch: {},
  computed: {},
};
</script>
<style>
.legend-img {
  width: 100%;
}

.legend-swatch{
  width:15px;
  height:15px;
  position: absolute;
}
.dynamic-legend-label{
  margin-left: 25px;
}

.dynamic-legend-container{
  background: white;
    padding: 1px 5px;
    /* margin: 0 10px; */
    box-shadow: lightgrey 2px 2px 5px;
}

.legend-swatch-class {
  margin-top:8px;
  margin-bottom:8px;
  line-height: 1 !important;
}

</style>